import ToastActions from '@store/toast/ToastActions';
import generateSelectedItemsDescription from './generateSelectedItemsDescription';
import {errorCommunicating} from 'utils/const';

// TODO needs to be removed probably.  This is an artifact of when api bulk
// actions were not available
export default async ({targets, areAllSelected, action, actionText}) => {
  return action().then(
    () =>
      ToastActions.addToast({
        message: actionText(generateSelectedItemsDescription({areAllSelected, targets})),
      }),
    () => ToastActions.addToast({message: errorCommunicating, type: 'error'})
  );
};
